import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { BuildingInsuranceTypeSelect } from '../BuildingInsuranceTypeSelect'

function BuildingInsuranceTypeSelectFormikField({
  Select = BuildingInsuranceTypeSelect,
  ...restProps
}) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default BuildingInsuranceTypeSelectFormikField
